import { login, logout, getInfo, loginByThirdSystem } from '@/api/sso/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import md5 from 'md5'
import { MessageBox } from 'element-ui'
import store from '@/store'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: []
    // token: getToken(),
    // router: getRouter(),
    // name: '',
    // avatar: '',
    // introduction: '',
    // roles: [],
    // routerData:[],
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  }
}

// const mutations = {
//   RESET_STATE: (state) => {
//     Object.assign(state, getDefaultState())
//   },
//   SET_TOKEN: (state, token) => {
//     state.token = token
//   },
//   SET_INTRODUCTION: (state, introduction) => {
//     state.introduction = introduction
//   },
//   SET_NAME: (state, name) => {
//     state.name = name
//   },
//   SET_AVATAR: (state, avatar) => {
//     state.avatar = avatar
//   },
//   SET_ROLES: (state, roles) => {
//     state.roles = roles
//   },
//   SET_ROUTER: (state, routerData) => {
//     state.routerData = routerData
//   }
// }
const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, code, uuid } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: md5(password), code: code, uuid: uuid }).then(response => {
        if (response.code !== '200') {
          // Message.error(response.message);
          alert(response.msg)
          resolve()
          return
        }
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(data)
      }).catch(error => {
        console.info(error)
        reject(error)
      })
    })
  },
  loginByThirdSystem({ commit }, data) {
    // const { username, password ,code,uuid} = userInfo
    console.info('aaa:', data)
    return new Promise((resolve, reject) => {
      loginByThirdSystem(data).then(response => {
        console.info(response)
        if (response.code !== '200') {
          // Message.error(response.message);
          alert(response.msg)
          resolve()
          return
        }
        const { data } = response
        console.info('data:' + data)
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(data)
      }).catch(error => {
        console.info(error)
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          MessageBox.alert('你的登录验证失败，请重新登录', '登录失败', {
            confirmButtonText: '重新登录',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
        }

        const { systems, name, avatar, user } = data

        // roles must be a non-empty array
        if (!systems || systems.length <= 0) {
          // reject('getInfo: 你无权登录系统')
          MessageBox.alert('你无权登录系统，请联系系统管理员', '登录失败', {
            confirmButtonText: '重新登录',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
        }
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_USER', user)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
